import apiClient from './apiClient';

export interface QueryParams {
  startWarehouse?: string;
  lastWarehouse?: string;
  startProduct?: string;
  lastProduct?: string;
  startBatch?: string;
  lastBatch?: string;
  startBoard?: string;
  lastBoard?: string;
  startDate?: string;
  lastDate?: string;
  processCode?: string;
  zeroStock?: number;   // 1=show all, 2=hide zero (default 2)
  showAmount?: boolean;
}

export interface ResultRow {
  board_no: string;
  warehouse_code: string;
  warehouse_name: string;
  product_code: string;
  batch_no: string;
  color_code: string;
  color_name: string;
  unit: string;
  stock_qty: number;
  stock_amount: number;
  avg_unit_price: number;
  entry_date: string | null;
  rd_shelf_no: string;
  width: number;
  weight: number;
  spec1: number;
  spec2: number;
  remark: string;
}

export interface UnitSummary {
  unit: string;
  total_qty: number;
  total_amount: number;
  avg_unit_price: number;
}

export interface QueryResponse {
  data: ResultRow[];
  summary: UnitSummary[];
  total: number;
  message?: string;
}

export const m309Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/m309/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/m309/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
